import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { UserProvider } from './UserContext';
import { TicketCountProvider } from './TicketCountContext';
import posthog from 'posthog-js';

if (process.env.REACT_APP_POSTHOG_KEY) {
    posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
      api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com',

      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,

      disable_session_recording: true,

      capture_performance: false,

      loaded: (posthogInstance) => {
          posthogInstance.register({
              environment: process.env.NODE_ENV,
              app: 'abroadify',
          });
      },
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <UserProvider>
    <TicketCountProvider>
      <App />
    </TicketCountProvider>
  </UserProvider>,
);
